import type { FontId } from "@/components/landing/StoreCustomizer/types";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@/components/ui/Icon";

interface FontPickerProps {
	label: string;
	fonts: Record<FontId, string>;
	fontId: FontId;
	onChange: (id: FontId) => void;
}

function FontPicker(prop: FontPickerProps) {
	const { label, fonts, fontId, onChange } = prop;
	return (
		<div className="flex items-center justify-between gap-3">
			<p className="text-xs font-semibold text-muted-foreground">{label}</p>
			<div className="relative">
				<select
					aria-label={label}
					value={fontId}
					onChange={(e) => onChange(e.target.value as FontId)}
					className="input w-auto appearance-none py-1.5 ps-3 pe-7 text-xs"
				>
					{(Object.keys(fonts) as FontId[]).map((id) => (
						<option key={id} value={id}>
							{fonts[id]}
						</option>
					))}
				</select>
				<Icon
					icon={faChevronDown}
					size={13}
					className="pointer-events-none absolute end-2 top-1/2 -translate-y-1/2 text-muted-foreground"
				/>
			</div>
		</div>
	);
}

export default FontPicker;
